<header class="">
    <div class="app-header-logo">
        <app-logo-default [resizable]="true"></app-logo-default>
    </div>
    <div class="app-header-content"></div>
</header>